import {jsonp} from "vue-jsonp";

export default {
  userGeo: null,

  // 调用此方法以获取地理位置信息，并返回解析后的地址信息
  async fetchCurrentGeo() {
    try {
      if (navigator.geolocation) {
        const position = await this.getCurrentGeoPosition();
        await this.handleGeoPosition(position);
        return this.userGeo;
      } else {
        console.warn('该浏览器不支持获取地理位置。');
        return this.getDefaultGeo(); // 返回默认值
      }
    } catch (error) {
      console.error('获取地理位置失败:', error);
      return this.getDefaultGeo(); // 出现错误时返回默认值
    }
  },

  // 获取当前地理位置信息的 Promise 封装
  getCurrentGeoPosition() {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, () => {
        console.warn('无法获取地理位置信息，返回默认位置');
        resolve(this.getDefaultPosition()); // 如果获取失败，返回默认位置
      });
    });
  },

  // 处理位置信息，并调用百度地图 API
  async handleGeoPosition(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    console.log('------', latitude, longitude)

    // 获取并处理百度地图坐标点信息
    await this.fetchBaiduMapData(latitude, longitude);
  },

  // 请求百度地图 API，并处理响应
  async fetchBaiduMapData(latitude, longitude) {
    try {

      const data = await jsonp(
        `https://api.map.baidu.com/reverse_geocoding/v3/?ak=NHvhXvyEPsPTZIxrgxXmktZ5eTTbzqAx&output=json&coordtype=wgs84ll&location=${latitude},${longitude}`
      );

      //console.log('=============data', data)
      if (data.status === 0) {
        const result = data.result;
        const addressComponent = result.addressComponent;
        let userId = localStorage.getItem('id');
        userId = userId ? Number(userId) : 0;
        let readAddress = addressComponent.province + addressComponent.city + addressComponent.district + addressComponent.town + addressComponent.street
        // 解析百度地图 API 返回的数据并存入 userGeo
        this.userGeo = {
          formattedAddress: result.formatted_address,
          longitude: result.location.lng,
          latitude: result.location.lat,
          country: addressComponent.country,
          province: addressComponent.province,
          city: addressComponent.city,
          district: addressComponent.district,
          town: addressComponent.town,
          street: addressComponent.street,
          business: result.business,
          edz: result.edz ? result.edz.name : '',  // 开发区名称
          cityCode: result.cityCode,
          adcode: addressComponent.adcode,
          readAddress: readAddress,
          userId: userId //
        };
        //console.log('User Geo Data:', JSON.stringify(this.userGeo));
      } else {
        console.error('百度地图 API 返回错误:', data);
        this.userGeo = this.getDefaultGeo();
      }
    } catch (error) {
      console.error('请求百度地图 API 出错:', error.message);
      this.userGeo = this.getDefaultGeo(); // 请求失败时返回默认值
    }
  },

  // 默认地理位置
  getDefaultPosition() {
    return {
      coords: {
        latitude: 0, // 默认纬度
        longitude: 0, // 默认经度
      }
    };
  },

  // 默认地理信息
  getDefaultGeo() {
    let userId = localStorage.getItem('id');
    userId = userId ? Number(userId) : 0;
    return {
      formattedAddress: '未知地址',
      longitude: 0,
      latitude: 0,
      country: '未知国家',
      province: '未知省份',
      city: '未知城市',
      district: '未知区域',
      town: '未知街道',
      street: '未知街道',
      business: '',
      edz: '',
      cityCode: '',
      adcode: '',
      userId: userId,
      readAddress: ''
    };
  }
};



// WEBPACK FOOTER //
// ./src/utils/geo-location.js